import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  account: null,
  mobileHome: null,
  error: false,
  errorStatus: null,
  success: false,
  loading: false,
  loaded: false,
  realMobileHome: null,
  switch:false
};
const initMobileHomeStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded: false,
    errorStatus: null
  });
};

const setMobileHome = (state, action) => {
  // console.log('RED mob home', action)
  return updateObject(state, {
    realMobileHome: action.realMobileHome,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchMobileHomeFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};
const changeMobileHomeFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true,
    errorStatus: action.errorStatus
  });
};

const changeMobileHomeSuccess = (state, action) => {

  return updateObject(state, {
    loading: false,
    success: true
  });
};
const resetMobileHomeErrorSuccess = (state, action) => {
  return updateObject(state, {
    success:false,
    error:false
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_MOBILE_HOME_START:
      return initMobileHomeStart(state, action);
    case actionTypes.SET_MOBILE_HOME:
      return setMobileHome(state, action);
    case actionTypes.FETCH_MOBILE_HOME_FAILED:
      return fetchMobileHomeFailed(state, action);
    case actionTypes.CHANGE_MOBILE_HOME_SUCCESS:
      return changeMobileHomeSuccess(state, action);
    case actionTypes.CHANGE_MOBILE_HOME_FAILED:
      return changeMobileHomeFailed(state, action);
    case actionTypes.RESET_MOBILE_HOME_ERROR_SUCCESS:
      return resetMobileHomeErrorSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
